

export class CreateOrUpdateDocumentVaultDto implements ICreateOrUpdateDocumentVaultDto {
    id!: number;
    documentName!: string | undefined;
    documentUri!: string | undefined;
    documentType!: string | undefined;
    documentPath!: string | undefined;
    designationId!: number | undefined;
    isActive!: boolean;

    constructor(data?: ICreateOrUpdateDocumentVaultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentName = _data["documentName"];
            this.documentUri = _data["documentUri"];
            this.documentType = _data["documentType"];
            this.documentPath = _data["documentPath"];
            this.designationId = _data["designationId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateOrUpdateDocumentVaultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateDocumentVaultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentName"] = this.documentName;
        data["documentUri"] = this.documentUri;
        data["documentType"] = this.documentType;
        data["documentPath"] = this.documentPath;
        data["designationId"] = this.designationId;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateOrUpdateDocumentVaultDto {
    id: number;
    documentName: string | undefined;
    documentUri: string | undefined;
    documentType: string | undefined;
    documentPath: string | undefined;
    designationId: number | undefined;
    isActive: boolean;
}

